import { useEffect, useRef, useState } from "react";
import useUserProvider from "@/core/dataProviders/providers/auth/useUserProvider";
import useUserSubscriptionProvider from "@/core/dataProviders/providers/auth/useUserSubscriptionProvider";
import { useRouter } from "next/router";
import {
  AuthorType,
  CategoryType,
  GalleryType,
  IssueType,
  PageType,
  PostType,
  TopicType,
} from "@/core/types/contentTypes";
import { buildPageViewOptions } from "@/utils/buildPageViewOptions";
import { pushToDataLayer } from "@/utils/pushToDataLayer";
import { useTrackBeamEvent } from "@/hooks/useTrackBeamEvent";

export default function useTrackPageView(
  pageType: string,
  page?: PostType | CategoryType | TopicType | PageType | AuthorType | IssueType | null,
  gallery?: GalleryType | null | undefined // stupid quick workaround for the moment until refactored
) {
  const addBeamTrackEvent = useTrackBeamEvent();
  const router = useRouter();
  const [user] = useUserProvider();
  const [subscriptions] = useUserSubscriptionProvider();
  const [pageViewTracked, setPageViewTracked] = useState<boolean>(false);

  const post = pageType === "article" || pageType === "article-gallery" ? (page as PostType) : null;
  const topic = pageType === "topic" ? (page as TopicType) : null;
  const topicCategory = topic?.name || "topic"; // @todo Stupid, check with data team

  const issue = pageType === "issue" ? (page as IssueType) : null;
  const issueCategory = issue?.title || "issue"; // @todo Stupid, check with data team

  const pageTypesWithContent = ["article", "article-gallery", "page", "topic"]; // @Todo Author maybe?
  const hasContent = pageTypesWithContent.includes(pageType);
  const hasGallery = (gallery?.images.length ?? 0) > 1;

  // Resets on Route Change
  useEffect(() => {
    setPageViewTracked(false);
  }, [router.asPath]);

  useEffect(() => {
    // Wait for user/subscription data to be provided. NULL means not ready
    if (user === null || subscriptions === null || pageViewTracked) return;

    const postIdFromUrl = router.asPath.match(/^\/(\d+)/);
    // If post is set and doesnt match current url skip
    if (post && postIdFromUrl && postIdFromUrl[1] !== post.id.toString()) return;

    setPageViewTracked(true);
    const pageViewOption = buildPageViewOptions(
      user,
      subscriptions,
      post,
      pageType,
      hasContent,
      issue ? issueCategory : topicCategory,
      hasGallery,
      router.asPath
    );
    pushToDataLayer(pageViewOption);
    addBeamTrackEvent(pageViewOption);
  }, [pageViewTracked, router.asPath, user, subscriptions]);

  // const track = useCallback(() => {
  //     const pageViewOption = buildPageViewOptions(user, subscriptions, null, pageType, hasContent);
  //     pushToDataLayer(pageViewOption);
  //   },
  // [router]);

  // return { track };
}
